<template>
        <div id='bindalipay'>
              <NavTop title='绑定支付宝'/>
              <div class="content" v-if="isset===true">
                <div class="alipaycon">
                    <div class="alipaycon-left"><img src='~@/assets/img/zfb.jpg'/></div>
                    <div class="alipaycon-right">
                        <div>{{realname}}</div>
                        <div>{{alipay}}</div>
                    </div>
                </div>       
              </div> 
              <div class='content' v-else-if="isset===false">
                  <div class="row">
                     <div class="label">支付宝账号</div>
                     <div class="maininput"><input placeholder="请输入支付宝账号" v-model="alipay"/></div>
                  </div>
                  <div class="tiprow">
                        <div class="tiprow-icon"><img src="~@/assets/img/security.png"/></div>
                        <div>信息加密处理，保障个人隐私不泄露</div>
                  </div>
                  <div class="row">
                     <div class="label">持卡人姓名</div>
                     <div class="maininput">{{realname}}</div>
                  </div>
                  <div class="tiprow">
                     <div>* 仅用于公司打款到支付宝使用</div>
                   </div>
                   <div class="submitbtn_out">
                     <div class="submitbtn" @click="saveAlipay">提交</div>
                   </div>
              </div>
        </div>
</template>
<script>
import NavTop from '@/components/navtop'
import { Icon ,Dialog } from 'vant';

export default {
  data(){
      return{
          realname:'',
          alipay:'',
          isset:''
      }
  },  
  name: 'bindalipay',
  created(){
      this.getList()
  },
  methods:{
      getList(){
          this.$post("/user/getUserInfo",{}).then((data)=>{
            if(data.result.success){
               if(data.result.info.realname==null || data.result.info.realname==''){
                  Dialog.confirm({
                     title: '温馨提醒',
                     message: '您的姓名还未设置，请设置完姓名后再来绑定',
                     })
                     .then(() => {
                         this.$go("/myprofile")
                     })
                     .catch(() => {
                         this.$go("/my")
                     });
               }else{ 
                  this.realname=data.result.info.realname
               }
                if(data.result.info.alipay!=null && data.result.info.alipay!=''){
                    this.alipay=data.result.info.alipay
                    this.isset=true
                }else{
                    this.isset=false
                }
            }else{
               this.$toast(data.result.info)
            }
          })
      },
      saveAlipay(){
         if(this.alipay==''||this.alipay==undefined){
             this.$toast("请先输入支付宝账号");return false;
         }
         this.$post("/user/saveAlipay",{alipay:this.alipay}).then((data)=>{
              this.$toast(data.result.info)
              this.getList()
         })
      }
  },
  components:{
      NavTop,
      [Icon.name]:Icon,
      [Dialog.Component.name]: Dialog.Component
  }
}
</script>
<style scoped>
#bindalipay{background-color:#F6F6F6;min-height: 100vh;}
.content{border-radius: 0.2rem;background-color: #fff;display: flex;flex-flow: column nowrap;margin: 0.3rem;}
.row{padding: 0.4rem;display: flex;border-bottom: 1px solid #e7e7e7;}
.label{text-align: left;width:2.5rem;font-size:0.35rem;color:#333;}
.maininput{flex:1 0 auto;text-align: left;}
.maininput input{text-align: left;font-size:0.35rem;color:#333;width:100%;}
.submitbtn{background-color:#ee0a24;color:#fff;font-size:0.35rem;padding: 0.25rem;border-radius: 0.1rem;}
.tiprow{font-size:0.25rem;display: flex;align-items: center;background-color: #F6F6F6;padding: 0.3rem;}
.tiprow-icon{display: flex;align-items: center;margin-right: 0.1rem;}
.tiprow-icon img{width:0.3rem;height:0.3rem;}
.alipaycon{display: flex;align-items: center;flex-flow: row nowrap;padding: 0.35rem;}
.alipaycon-left img{width:1.2rem;height:1.2rem;}
.alipaycon-right{display: flex;flex-flow: column nowrap;text-align: left;padding-left: 0.3rem;}
</style>


